export default __webpack_public_path__ + "static/media/Group9221.e524d7a4.svg";